import { LOADING_STARTED } from '../../constants';
import * as types from '../constants';

function listReducer(state = [], action) {
  switch (action.type) {
    case LOADING_STARTED:
      return [];
    case types.IMPORT_CUSTOMERS:
      return [...state, ...action.response.result];
    case types.ADD_CUSTOMER:
      return [...state, action.response.result];
    case types.DELETE_CUSTOMER:
      return state.filter(id => id !== action.customerId);
    default:
      return state;
  }
}

export default listReducer;
